import { TspFieldType } from '@entities/tsp'

export const findServersEnumId = (service) =>
  service?.params?.find((item) => item.type === TspFieldType.ComboBox && item.name === 'server')?.enumId || null
